require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-writing-completion-blocks-with-closures-in-swift.json") })
        }
      }, "path---blog-writing-completion-blocks-with-closures-in-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-writing-completion-blocks-with-closures-in-swift!./.cache/json/blog-writing-completion-blocks-with-closures-in-swift.json
// module id = 1151
// module chunks = 231608221292675